export enum CustomerType {
  SPARKASSE = 'SPARKASSE',
  RECHENZENTRUM = 'RECHENZENTRUM',
  KOMMUNE = 'KOMMUNE',
  INTERN = 'INTERN',
}
